export const FilterSkeleton = ({ count = 4 }) => {
  return (
    <div className="flex justify-center gap-3 py-3 bg-pattern">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="w-16 h-10 rounded-lg bg-slate-300 animate-pulse"
        ></div>
      ))}
    </div>
  );
};

export const MeetingSkeleton = ({ count = 3 }) => {
  return (
    <div className="flex justify-center gap-4 py-4 bg-pattern">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="w-28 h-10 rounded-md bg-slate-300 animate-pulse"
        ></div>
      ))}
    </div>
  );
};

export const MatchCardSkeleton = () => {
  return (
    <li className="relative text-white p-4 rounded-lg shadow-lg w-full max-w-4xl mx-auto overflow-hidden animate-pulse my-5">
      <div
        className="absolute inset-0"
        style={{
          background: `linear-gradient(to right, #334155dd, #1e293bdd)`,
          zIndex: 0,
        }}
      />
      <div className="absolute inset-0 bg-black opacity-60 z-1" />
      <div className="relative z-10 space-y-4">
        <div className="h-6 bg-gray-500 rounded w-1/2 mx-auto" />
        <div className="h-4 bg-gray-600 rounded w-2/3 mx-auto" />
        <div className="flex justify-between items-center border-b border-gray-600 pb-2 flex-wrap gap-2">
          <div className="flex w-full sm:w-2/5 items-center space-x-2">
            <div className="w-10 h-10 rounded-full bg-gray-500 border" />
            <div className="h-4 w-24 bg-gray-600 rounded" />
          </div>
          <div className="w-6 h-4 bg-gray-600 rounded self-center" />
          <div className="flex w-full sm:w-2/5 items-center space-x-2 justify-end">
            <div className="h-4 w-24 bg-gray-600 rounded" />
            <div className="w-10 h-10 rounded-full bg-gray-500 border" />
          </div>
        </div>
        <div className="h-4 bg-gray-600 w-32 rounded mx-auto mt-2" />
      </div>
    </li>
  );
};
